/* ============================================================
   THE ARTISAN NOOK - shared site core (all pages)
   header + footer injection · smooth scroll · nav state ·
   scroll reveals · cart drawer · magnetic buttons · product data
   ============================================================ */
(function () {
  "use strict";

  /* ---------- product catalogue (single source) ---------- */
  const P = (window.PRODUCTS = [
    {
      id: "love", name: "Love in the Air", tagline: "Warmth in every breath", type: "candle",
      sizes: [
        { oz: 4,  label: "4 oz",  price: 18, burnHr: 20, wicks: 1, desc: "Gift & travel" },
        { oz: 8,  label: "8 oz",  price: 28, burnHr: 40, wicks: 1, desc: "Everyday ritual" },
        { oz: 14, label: "14 oz", price: 42, burnHr: 60, wicks: 2, desc: "Signature piece" }
      ],
      price: 42, accent: "var(--love)", hex: "#b07a8e",
      imgs: [
        { src: "assets/products/love-studio.png", alt: "Love in the Air - matte plum vessel with gold lid", type: "studio" },
        { src: "assets/products/sleeve-love-air.jpg", alt: "Love in the Air - hand-illustrated sleeve artwork", type: "sleeve" },
        { src: "assets/products/love-sizes.jpg", alt: "Love in the Air - all three sizes", type: "detail" },
        { src: "assets/products/love-lifestyle.png", alt: "Love in the Air in a modern room setting", type: "lifestyle" },
        { src: "assets/products/candles-trio.jpg", alt: "Love in the Air alongside the collection", type: "lifestyle" }
      ],
      img: "assets/products/love-studio.png", sleeve: "assets/products/sleeve-love-air.jpg", vid: "https://res.cloudinary.com/dil2wjucl/video/upload/tan/worlds/love.mp4",
      mood: "soft romance", notes: "bergamot · neroli & rose · sandalwood & leather",
      notes_top: "Bergamot, Petitgrain & Clove", notes_top_sub: "bright, spiced citrus open",
      notes_heart: "Neroli, Rose & Jasmine", notes_heart_sub: "orange blossom, lavender & labdanum",
      notes_base: "Sandalwood & Leather", notes_base_sub: "warm amber & tobacco leaves",
      best_tags: ["Date nights", "Unwinding", "Gifting", "Romance", "Evening rituals"],
      ritual_when: "Light 30 minutes before you settle in - gives the top note time to bloom.",
      ritual_first: "First burn: minimum 2 full hours to create a complete melt pool and prevent tunneling.",
      ritual_pair: "Set beside the Ceramic Matchbox with Drawer. Dim the lights. Put the phone away.",
      story: "Inspired by quiet, intimate evenings - a warm romantic blend of bergamot, petitgrain, and clove with a heart of neroli, rose, and orange blossom, grounded by sandalwood, leather, and amber.",
      story_sub: "The candle for when the day is finally yours."
    },
    {
      id: "first-rain", name: "First Rain", tagline: "Earth's first breath", type: "candle",
      sizes: [
        { oz: 4,  label: "4 oz",  price: 18, burnHr: 20, wicks: 1, desc: "Gift & travel" },
        { oz: 8,  label: "8 oz",  price: 28, burnHr: 40, wicks: 1, desc: "Everyday ritual" },
        { oz: 14, label: "14 oz", price: 42, burnHr: 60, wicks: 2, desc: "Signature piece" }
      ],
      price: 42, accent: "var(--rain)", hex: "#6e8fa5",
      imgs: [
        { src: "assets/products/rain-studio.png", alt: "First Rain - matte steel-blue vessel with gold lid", type: "studio" },
        { src: "assets/products/sleeve-first-rain.jpg", alt: "First Rain - hand-illustrated sleeve artwork", type: "sleeve" },
        { src: "assets/products/rain-giftbox.jpg", alt: "First Rain - all three sizes in gift boxes", type: "detail" },
        { src: "assets/products/rain-lifestyle.jpg", alt: "First Rain lit, with peacock feather - warm evening setting", type: "lifestyle" },
        { src: "assets/products/rain-giftbox-2.jpg", alt: "First Rain gift set - The Artisan Nook branded box", type: "lifestyle" }
      ],
      img: "assets/products/rain-studio.png", sleeve: "assets/products/sleeve-first-rain.jpg", vid: "https://res.cloudinary.com/dil2wjucl/video/upload/tan/worlds/first-rain.mp4",
      mood: "fresh reset", notes: "fresh rain & soft soil · patchouli · damp woods",
      notes_top: "Fresh Rain & Soft Soil", notes_top_sub: "wet earth, fresh atmosphere",
      notes_heart: "Patchouli", notes_heart_sub: "grounding, earthy heart",
      notes_base: "Damp Woods & Musk", notes_base_sub: "cool forest floor, lingering trail",
      best_tags: ["Morning ritual", "Mindful focus", "WFH", "Fresh reset", "Rainy days"],
      ritual_when: "Light first thing in the morning or at the start of a work session - brings focus and freshness.",
      ritual_first: "First burn: minimum 2 full hours to create a complete melt pool and prevent tunneling.",
      ritual_pair: "Open a window slightly. Let the outside drift in. Nothing else required.",
      story: "Inspired by the first drops of rain falling on soft earth. Fresh rain and soft soil open with that unmistakable earthy burst, patchouli grounds the heart, and damp woods with musk trail gently.",
      story_sub: "The candle for mornings that deserve a proper beginning."
    },
    {
      id: "soulful-brew", name: "Soulful Brew", tagline: "Deeply intense", type: "candle",
      sizes: [
        { oz: 4,  label: "4 oz",  price: 18, burnHr: 20, wicks: 1, desc: "Gift & travel" },
        { oz: 8,  label: "8 oz",  price: 28, burnHr: 40, wicks: 1, desc: "Everyday ritual" },
        { oz: 14, label: "14 oz", price: 42, burnHr: 60, wicks: 2, desc: "Signature piece" }
      ],
      price: 42, accent: "var(--brew)", hex: "#6b4a3a",
      imgs: [
        { src: "assets/products/brew-studio.png", alt: "Soulful Brew - matte black vessel with gold lid", type: "studio" },
        { src: "assets/products/sleeve-soulful-brew.jpg", alt: "Soulful Brew - hand-illustrated sleeve artwork", type: "sleeve" },
        { src: "assets/products/brew-lifestyle.png", alt: "Soulful Brew - lit candle on marble table, woman in background", type: "lifestyle" },
        { src: "assets/products/brew-lifestyle-portrait.png", alt: "Soulful Brew - calm evening ritual on the couch", type: "lifestyle" },
        { src: "assets/products/candles-trio.jpg", alt: "Soulful Brew alongside the full collection", type: "lifestyle" }
      ],
      img: "assets/products/brew-studio.png", sleeve: "assets/products/sleeve-soulful-brew.jpg", vid: "https://res.cloudinary.com/dil2wjucl/video/upload/tan/worlds/soulfulbrew.mp4",
      mood: "cozy focus", notes: "coffee · sweet sugar · cream & santal vanilla",
      notes_top: "Rich Coffee", notes_top_sub: "bold, invigorating roast",
      notes_heart: "Sweet Sugar", notes_heart_sub: "gentle golden sweetness",
      notes_base: "Cream, Santal & Vanilla", notes_base_sub: "creamy coffee, sandalwood & deep vanilla",
      best_tags: ["Reading", "Journaling", "Deep focus", "Cozy evenings", "Work sessions"],
      ritual_when: "Light when you sit down to write, read, or work - anchors you to the moment.",
      ritual_first: "First burn: minimum 2 full hours to create a complete melt pool and prevent tunneling.",
      ritual_pair: "A hot drink - coffee, dark tea, or cocoa - and nothing else on the agenda.",
      story: "A grounded, coffeehouse-cozy scent for the hours you want to feel calm and capable. Bold coffee opens the experience, sweet sugar warms the center, and velvety cream with santal and vanilla soften the finish.",
      story_sub: "The candle for when you need to settle in and stay a while."
    },
    {
      id: "tropical-forest", name: "Tropical Forest", tagline: "Breathe the canopy", type: "candle",
      sizes: [
        { oz: 4,  label: "4 oz",  price: 18, burnHr: 20, wicks: 1, desc: "Gift & travel" },
        { oz: 8,  label: "8 oz",  price: 28, burnHr: 40, wicks: 1, desc: "Everyday ritual" },
        { oz: 14, label: "14 oz", price: 42, burnHr: 60, wicks: 2, desc: "Signature piece" }
      ],
      price: 42, accent: "var(--forest)", hex: "#4e6a52",
      imgs: [
        { src: "assets/products/tropical-lid.jpg", alt: "Tropical Forest - teal vessel with engraved gold lid", type: "studio" },
        { src: "assets/products/sleeve-tropical-forest.jpg", alt: "Tropical Forest - hand-illustrated sleeve artwork", type: "sleeve" },
        { src: "assets/products/tropical-bath.png", alt: "Tropical Forest - two wicks lit in a luxury bath setting", type: "lifestyle" },
        { src: "assets/products/tropical-lifestyle.png", alt: "Tropical Forest - on wooden tray with tropical plants", type: "lifestyle" },
        { src: "assets/products/tropical-books.jpg", alt: "Tropical Forest - evening reading nook setting", type: "lifestyle" }
      ],
      img: "assets/products/tropical-studio.jpg", sleeve: "assets/products/sleeve-tropical-forest.jpg", vid: "https://res.cloudinary.com/dil2wjucl/video/upload/tan/worlds/tropical.mp4",
      mood: "sunlit escape", notes: "tangerine & citrus · pineapple & coconut · rum & sugar",
      notes_top: "Tangerine, Orange Peel & Lemon", notes_top_sub: "crisp, bright sunlit citrus",
      notes_heart: "Pineapple & Coconut", notes_heart_sub: "lush, sweet tropical canopy",
      notes_base: "Warm Rum & Sugar", notes_base_sub: "smooth, decadent island finish",
      best_tags: ["Yoga", "Meditation", "Midday reset", "Nature lovers", "Calm routines"],
      ritual_when: "Light before yoga, meditation, or any time you need to step away from the noise.",
      ritual_first: "First burn: minimum 2 full hours to create a complete melt pool and prevent tunneling.",
      ritual_pair: "Silence, or soft ambient nature sounds. Breathe deeply. That's all.",
      story: "A vibrant sunlit escape that brings lush tropical energy into your room. Bright tangerine, orange peel, and lemon open with zest; pineapple and coconut envelop the heart; warm rum and sugar create a smooth, indulgent finish.",
      story_sub: "The candle for when the outside world is exactly where you want to be."
    },
    {
      id: "spice-it-up", name: "Spice It Up", tagline: "Festive warmth, bottled", type: "candle",
      sizes: [
        { oz: 4,  label: "4 oz",  price: 18, burnHr: 20, wicks: 1, desc: "Gift & travel" },
        { oz: 8,  label: "8 oz",  price: 28, burnHr: 40, wicks: 1, desc: "Everyday ritual" },
        { oz: 14, label: "14 oz", price: 42, burnHr: 60, wicks: 2, desc: "Signature piece" }
      ],
      price: 42, accent: "var(--spice)", hex: "#a65a3f",
      imgs: [
        { src: "assets/products/spice-studio.jpg", alt: "Spice It Up - white matte vessel with gold lettering", type: "studio" },
        { src: "assets/products/sleeve-spice-up.jpg", alt: "Spice It Up - hand-illustrated sleeve artwork", type: "sleeve" },
        { src: "assets/products/spice-lifestyle.jpg", alt: "Spice It Up - all three sizes on wooden riser with gold lid", type: "detail" },
        { src: "assets/products/spice-lit.jpg", alt: "Spice It Up - lit in a reading nook setting", type: "lifestyle" },
        { src: "assets/products/spice-trio.jpg", alt: "Spice It Up - three sizes displayed on walnut stand", type: "lifestyle" }
      ],
      img: "assets/products/spice-trio.jpg", sleeve: "assets/products/sleeve-spice-up.jpg", vid: "https://res.cloudinary.com/dil2wjucl/video/upload/tan/worlds/spice.mp4",
      mood: "festive warmth", notes: "clove & cinnamon · pumpkin buttercream · vanilla & smoke",
      notes_top: "Clove, Cinnamon & Nutmeg", notes_top_sub: "warm aromatic autumn spice",
      notes_heart: "Pumpkin & Buttercream", notes_heart_sub: "rich, decadent sweetness",
      notes_base: "Warm Vanilla & Smoke", notes_base_sub: "lingering fireplace warmth",
      best_tags: ["Gatherings", "Holiday decor", "Gifting", "Festive evenings", "Celebrations"],
      ritual_when: "Light when guests arrive or when you're setting the mood for a celebration.",
      ritual_first: "First burn: minimum 2 full hours to create a complete melt pool and prevent tunneling.",
      ritual_pair: "Warm drinks, good company, and a table worth gathering around.",
      story: "A festive, warm blend with playful seasonal energy. Aromatic clove, cinnamon, and nutmeg open bold; rich pumpkin and buttercream sweeten the heart; warm vanilla and cozy smoke linger like embers in the hearth.",
      story_sub: "The candle for the moments that turn a house into a home."
    },
    {
      id: "ceramic-matchbox", name: "Ceramic Matchbox with Drawer", tagline: "The ritual striker", type: "accessory",
      sizes: null, price: 18, accent: "var(--gilt)", hex: "#c9a86a",
      imgs: [
        { src: "assets/products/matchbox-studio.png", alt: "Ceramic Matchbox with Drawer - white matte ceramic with floral lid", type: "studio" },
        { src: "assets/products/matchbox-bloom.png", alt: "Ceramic Matchbox with Drawer - Bloom As You Are design with florals", type: "detail" },
        { src: "assets/customization/mb-4.jpg", alt: "Ceramic Matchbox with Drawer - lid open, red-tipped matches", type: "lifestyle" },
        { src: "assets/products/matchbox-art.png", alt: "Ceramic Matchbox with Drawer - custom illustrated art lid", type: "detail" }
      ],
      img: "assets/products/matchbox-studio.png", sleeve: "", vid: "",
      mood: "the ritual companion", notes: "hand-finished ceramic · customizable lid",
      best_tags: ["Ritual gifting", "Home decor", "Candle pairing", "Keepsake", "Customizable"],
      story: "Our bestselling striker - a hand-finished ceramic keepsake built to hold and outlast your matches. The smooth matte lid accepts custom photo prints, names, and dates. Strike a match. Start the ritual.",
      story_sub: "5.6 × 4.6 × 2.4 cm · Slide-out ceramic drawer · Fits standard matches (not included)."
    },
    {
      id: "car-diffuser", name: "Car Diffuser", tagline: "Your world, on the move", type: "accessory",
      sizes: null, price: 9, accent: "var(--amber)", hex: "#d98a4f",
      imgs: [
        { src: "assets/products/car-diffuser-studio.webp", alt: "Car Diffuser - glass bottle with braided rope and wooden bead cap, white background", type: "studio" },
        { src: "assets/products/car-diffuser-lifestyle.webp", alt: "Car Diffuser hanging from rearview mirror - Love in the Air scent", type: "lifestyle" }
      ],
      img: "assets/products/car-diffuser-studio.webp", vid: "",
      mood: "scent on the move", notes: "long-lasting · refillable",
      best_tags: ["Daily commute", "Road trips", "Car upgrade", "Gifting", "Refillable"],
      story: "Carry your favorite world with you - a discreet, refillable diffuser for the car vent that pairs with any of our fragrance oils. Long-lasting, clean, and quiet.",
      story_sub: "Refillable. Pairs with all five fragrance worlds."
    },
  ]);
  const byId = (id) => P.find((p) => p.id === id);
  window.productById = byId;
  const money = (n) => "$" + n;

  /* ---------- header ---------- */
  const headerHTML = `
  <div class="site-top" id="siteTop">
  <div class="announce">Free US shipping on orders <b>$50+</b> · Handcrafted in small batches</div>
  <header class="site-header" id="siteHeader">
    <a class="brand" href="index.html">The Artisan <span>Nook</span></a>
    <button class="burger" id="burger" aria-label="Menu"><span></span><span></span><span></span></button>
    <nav class="main-nav" id="mainNav">
      <div class="nav-item">
        <a href="shop.html">Shop</a>
        <div class="dropdown">
          <a href="shop.html#candles">Candles</a>
          <a href="product.html?id=ceramic-matchbox">Ceramic Matchbox with Drawer</a>
          <a href="shop.html#car">Car Accessories</a>
          <a href="customization.html">Gifting &amp; Custom</a>
        </div>
      </div>
      <div class="nav-item"><a href="index.html#worlds">Fragrance Worlds</a></div>
      <div class="nav-item"><a href="about.html">About</a></div>
      <div class="nav-item"><a href="customization.html">Customization</a></div>
      <div class="nav-item"><a href="contact.html">Contact</a></div>
    </nav>
    <div class="header-actions">
      <button class="icon-btn" id="cartBtn" aria-label="Open cart">Cart <span class="cart-count" id="cartCount" aria-live="polite">0</span></button>
    </div>
  </header>
  </div>`;

  /* ---------- footer ---------- */
  const footerHTML = `
  <footer class="site-footer">
    <div class="footer-top">
      <div class="footer-brand">
        <div class="brand">The Artisan Nook</div>
        <p>Handcrafted candles and fragrance rituals for calm, warmth, and character. Everyday moments deserve to be beautiful.</p>
      </div>
      <div class="footer-col">
        <h4>Shop</h4>
        <a href="shop.html#candles">Candles</a>
        <a href="product.html?id=ceramic-matchbox">Ceramic Matchbox with Drawer</a>
        <a href="shop.html#car">Car Accessories</a>
        <a href="customization.html">Gifting &amp; Custom</a>
        <a href="index.html#worlds">Fragrance Worlds</a>
        <a href="quiz.html">Find Your Scent</a>
      </div>
      <div class="footer-col">
        <h4>Help</h4>
        <a href="info.html#faq">FAQ</a>
        <a href="info.html#shipping">Shipping &amp; Returns</a>
        <a href="info.html#refund">Refund Policy</a>
        <a href="info.html#care">Candle Care</a>
        <a href="contact.html">Contact Us</a>
      </div>
      <div class="footer-col">
        <h4>Company</h4>
        <a href="about.html">About</a>
        <a href="customization.html">Customization</a>
        <a href="info.html#privacy">Privacy Policy</a>
        <a href="info.html#terms">Terms &amp; Conditions</a>
        <a href="info.html#accessibility">Accessibility</a>
      </div>
      <div class="footer-col newsletter">
        <h4>Join the ritual</h4>
        <p style="font-size:.86rem">Seasonal mood edits &amp; new worlds, occasionally.</p>
        <input type="email" placeholder="your@email.com" aria-label="Email" />
        <button class="btn btn-flame btn-sm" style="width:100%;justify-content:center">Subscribe</button>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© 2026 The Artisan Nook · theartisanook.com</span>
      <span class="socials">theartisannook2006@gmail.com<a href="https://instagram.com/theartisannookcandles" target="_blank" rel="noopener">Instagram</a></span>
    </div>
  </footer>
  <div class="drawer-scrim" id="scrim"></div>
  <aside class="cart-drawer" id="cartDrawer" aria-label="Cart">
    <div class="cart-head"><h3 class="serif">Your ritual</h3><button class="icon-btn" id="cartClose">Close ✕</button></div>
    <div id="cartBody"><p class="cart-empty">Your cart is empty - start with a bestseller.</p></div>
    <div class="cart-foot" id="cartFoot" style="display:none">
      <div style="display:flex;justify-content:space-between;margin-bottom:.4rem"><span>Subtotal</span><b id="cartTotal">$0</b></div>
      <p style="font-size:.78rem;color:rgba(43,42,40,.6);margin-bottom:.9rem" id="shipNote"></p>
      <button class="btn btn-flame" style="width:100%;justify-content:center">Checkout</button>
    </div>
  </aside>`;

  /* ---------- inject (static site only - Shopify renders these via Liquid) ---------- */
  if (!window.Shopify) {
    const hMount = document.getElementById("site-header") || document.body;
    if (document.getElementById("site-header")) hMount.outerHTML = headerHTML;
    else hMount.insertAdjacentHTML("afterbegin", headerHTML);
    (document.getElementById("site-footer") || document.body).insertAdjacentHTML(
      document.getElementById("site-footer") ? "beforebegin" : "beforeend", footerHTML
    );
    const sf = document.getElementById("site-footer"); if (sf) sf.remove();

    /* ---------- skip link + main landmark ---------- */
    const firstContent = document.querySelector("main, .page-hero, .hero, .section");
    if (firstContent && !document.getElementById("site-main")) firstContent.id = firstContent.id || "site-main";
    document.body.insertAdjacentHTML("afterbegin",
      `<a class="skip-link" href="#${firstContent ? firstContent.id : "site-main"}">Skip to content</a>`);
  }

  /* ---------- current-page nav state ---------- */
  const here = location.pathname.split("/").pop() || "index.html";
  document.querySelectorAll(".main-nav a, .footer-col a").forEach((a) => {
    const href = (a.getAttribute("href") || "").split("#")[0].split("?")[0];
    if (href === here) a.setAttribute("aria-current", "page");
  });

  /* ---------- smooth scroll (Lenis) ---------- */
  let lenis = null;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  // keep in step with home.js: touch devices count as narrow (see note there re: Desktop-site mode)
  const narrow = matchMedia("(max-width: 860px)").matches ||
    matchMedia("(hover: none) and (pointer: coarse)").matches;
  if (typeof Lenis !== "undefined" && !reduced && !narrow) {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    if (typeof gsap !== "undefined" && gsap.ticker) {
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
      if (window.ScrollTrigger) lenis.on("scroll", ScrollTrigger.update);
    } else {
      const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
  }
  function scrollTo(target) {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -104, duration: 1.1 });
    else el.scrollIntoView({ behavior: "smooth" });
  }
  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const url = new URL(a.href, location.href);
    const norm = (p) => p.replace(/index\.html$/, "");
    if (norm(url.pathname) === norm(location.pathname) && url.hash && document.querySelector(url.hash)) {
      e.preventDefault();
      scrollTo(url.hash);
      document.getElementById("mainNav").classList.remove("open");
    }
  });

  /* ---------- sticky header state ---------- */
  const header = document.getElementById("siteHeader");
  const onScroll = () => {
    const solid = window.scrollY > window.innerHeight * 0.75 || document.body.dataset.solidHeader === "true";
    header.classList.toggle("solid", solid);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu ---------- */
  const burger = document.getElementById("burger");
  const mainNav = document.getElementById("mainNav");
  burger.setAttribute("aria-expanded", "false");
  burger.addEventListener("click", () => {
    const open = mainNav.classList.toggle("open");
    burger.setAttribute("aria-expanded", String(open));
  });
  mainNav.addEventListener("click", (e) => {
    if (e.target.closest("a")) { mainNav.classList.remove("open"); burger.setAttribute("aria-expanded", "false"); }
  });

  /* ---------- scroll reveals - scroll-driven (robust everywhere) ---------- */
  function bindReveals(root = document) {
    root.querySelectorAll("[data-stagger]:not([data-bound])").forEach((el) => {
      el.setAttribute("data-bound", "");
      [...el.children].forEach((k, i) => (k.style.transitionDelay = i * 80 + "ms"));
    });
    runInView();
  }
  window.bindReveals = bindReveals;

  function animateCount(el) {
    if (el.dataset.done) return; el.dataset.done = "1";
    const end = parseFloat(el.dataset.count), suf = el.dataset.suffix || "";
    if (reduced) { el.textContent = end + suf; return; }
    const t0 = performance.now(), dur = 1200;
    (function step(t) { const k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + suf; if (k < 1) requestAnimationFrame(step); })(t0);
  }
  function runInView() {
    const trigger = innerHeight * 0.9;
    document.querySelectorAll(".reveal:not(.in), [data-stagger]:not(.in), .split:not(.in)").forEach((el) => {
      if (el.getBoundingClientRect().top < trigger) el.classList.add("in");
    });
    document.querySelectorAll("[data-count]:not([data-done])").forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight * 0.85) animateCount(el);
    });
    // pause ambient autoplay videos when far offscreen (saves battery/decode)
    document.querySelectorAll("video[autoplay]").forEach((v) => {
      const r = v.getBoundingClientRect();
      const visible = r.bottom > -200 && r.top < innerHeight + 200;
      if (visible && v.paused) v.play().catch(() => {});
      else if (!visible && !v.paused) v.pause();
    });
  }
  window.__runInView = runInView;
  addEventListener("scroll", runInView, { passive: true });
  if (window.__lenis) window.__lenis.on("scroll", runInView);
  addEventListener("resize", runInView);
  bindReveals();
  // safety sweep in case first paint/scroll events are delayed
  let sweeps = 0; const sweep = setInterval(() => { runInView(); if (++sweeps > 12) clearInterval(sweep); }, 250);

  /* ---------- magnetic buttons (desktop) ---------- */
  if (!reduced && matchMedia("(pointer:fine)").matches) {
    document.querySelectorAll(".btn-flame").forEach((b) => {
      b.addEventListener("mousemove", (e) => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.18}px, ${(e.clientY - r.top - r.height / 2) * 0.28 - 3}px)`;
      });
      b.addEventListener("mouseleave", () => (b.style.transform = ""));
    });
  }

  /* ---------- cart (persisted - static site only) ---------- */
  if (!window.Shopify) {
  let cart = [];
  try { cart = JSON.parse(localStorage.getItem("an_cart")) || []; } catch (e) { cart = []; }
  cart = cart.filter((i) => i && byId(i.id) && i.qty > 0); // drop stale/unknown ids from older versions
  const saveCart = () => { try { localStorage.setItem("an_cart", JSON.stringify(cart)); } catch (e) {} };
  const drawer = document.getElementById("cartDrawer");
  const scrim = document.getElementById("scrim");
  const openCart = () => {
    drawer.classList.add("open"); scrim.classList.add("open");
    setTimeout(() => document.getElementById("cartClose").focus(), 450);
  };
  const closeCart = () => {
    drawer.classList.remove("open"); scrim.classList.remove("open");
    document.getElementById("cartBtn").focus();
  };
  document.getElementById("cartBtn").addEventListener("click", openCart);
  document.getElementById("cartClose").addEventListener("click", closeCart);
  scrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (drawer.classList.contains("open")) closeCart();
    const nav = document.getElementById("mainNav");
    if (nav.classList.contains("open")) { nav.classList.remove("open"); document.getElementById("burger").setAttribute("aria-expanded", "false"); }
  });

  /* newsletter (prototype-local confirmation) */
  document.querySelectorAll(".newsletter").forEach((col) => {
    const btn = col.querySelector("button"), input = col.querySelector("input");
    if (!btn || !input) return;
    btn.addEventListener("click", () => {
      if (!input.value.trim() || !input.value.includes("@")) { input.focus(); return; }
      col.querySelector("h4").textContent = "You're on the list";
      input.value = ""; input.placeholder = "Thank you ✦";
    });
  });

  function renderCart() {
    const body = document.getElementById("cartBody");
    const foot = document.getElementById("cartFoot");
    document.getElementById("cartCount").textContent = cart.reduce((s, i) => s + i.qty, 0);
    if (!cart.length) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty - start with a bestseller.</p>';
      foot.style.display = "none"; return;
    }
    body.innerHTML = cart.map((i) => {
      const p = byId(i.id);
      const media = p.img ? `<img src="${p.img}" alt="">` : `<div style="width:56px;height:70px;border-radius:8px;background:${p.hex}"></div>`;
      return `<div class="cart-line">${media}<div><div class="cl-name">${p.name} ${p.size}</div>
        <div style="font-size:.8rem;color:rgba(43,42,40,.55)">Qty ${i.qty}</div></div>
        <div class="cl-price">${money(p.price * i.qty)}</div>
        <button class="cl-remove" data-remove="${p.id}" aria-label="Remove ${p.name} from cart">✕</button></div>`;
    }).join("");
    const total = cart.reduce((s, i) => s + byId(i.id).price * i.qty, 0);
    document.getElementById("cartTotal").textContent = money(total);
    const left = 50 - total;
    document.getElementById("shipNote").innerHTML = left > 0
      ? `Add <b>${money(left)}</b> more for free US shipping.` : "You've unlocked free US shipping ✓";
    foot.style.display = "block";
  }
  window.addToCart = (ids, qty = 1) => {
    String(ids).split(",").forEach((id) => {
      id = id.trim();
      if (!byId(id)) return;
      const line = cart.find((i) => i.id === id);
      if (line) line.qty += qty; else cart.push({ id, qty });
    });
    saveCart(); renderCart(); openCart();
  };
  renderCart(); // reflect persisted cart on load
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-add]");
    if (b) { e.preventDefault(); window.addToCart(b.dataset.add); return; }
    const r = e.target.closest("[data-remove]");
    if (r) {
      e.preventDefault();
      const idx = cart.findIndex((i) => i.id === r.dataset.remove);
      if (idx > -1) { cart[idx].qty -= 1; if (cart[idx].qty <= 0) cart.splice(idx, 1); }
      saveCart(); renderCart();
    }
  });
  } /* end if (!window.Shopify) - static cart */

  /* ============================================================
     WOW LAYER (cursor · progress · transitions · marquee ·
     split-text · count-up · card tilt)  - reduced-motion safe
     ============================================================ */
  const fine = matchMedia("(pointer:fine)").matches;

  /* ---- scroll progress thread ---- */
  const bar = document.createElement("div");
  bar.className = "scroll-progress";
  document.body.appendChild(bar);
  const updateBar = () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    bar.style.width = (h > 0 ? (scrollY / h) * 100 : 0) + "%";
  };
  addEventListener("scroll", updateBar, { passive: true });
  if (window.__lenis) window.__lenis.on("scroll", updateBar);
  updateBar();

  /* ---- ember cursor (the "matchstick" glow) ---- */
  if (fine && !reduced) {
    const halo = document.createElement("div"); halo.className = "ember-cursor";
    const dot = document.createElement("div"); dot.className = "ember-dot";
    document.body.append(halo, dot);
    let tx = innerWidth / 2, ty = innerHeight / 2, hx = tx, hy = ty;
    addEventListener("mousemove", (e) => { tx = e.clientX; ty = e.clientY; dot.style.transform = `translate(${tx}px,${ty}px)`; }, { passive: true });
    (function follow() { hx += (tx - hx) * 0.16; hy += (ty - hy) * 0.16; halo.style.transform = `translate(${hx}px,${hy}px)`; requestAnimationFrame(follow); })();
    const hot = (on) => document.body.classList.toggle("cursor-hot", on);
    document.addEventListener("mouseover", (e) => { if (e.target.closest("a,button,.card,.world,.bundle,input,textarea,[data-cursor]")) hot(true); });
    document.addEventListener("mouseout", (e) => { if (e.target.closest("a,button,.card,.world,.bundle,input,textarea,[data-cursor]")) hot(false); });
    addEventListener("mouseleave", () => { halo.style.opacity = 0; dot.style.opacity = 0; });
    addEventListener("mouseenter", () => { halo.style.opacity = 1; dot.style.opacity = 1; });
  }

  /* ---- page transitions (warm wipe) ---- */
  if (!reduced) {
    const pt = document.createElement("div");
    pt.className = "page-transition";
    pt.innerHTML = '<span class="pt-mark">The Artisan Nook</span>';
    document.body.appendChild(pt);
    const ptNavDelay = narrow ? 320 : 520;
    const ptIntroDur = narrow ? ".32s" : ".6s";
    // load intro: start covered (from top), then retract upward to reveal the page.
    pt.style.transform = "scaleY(1)"; pt.style.transformOrigin = "top";
    setTimeout(() => {
      pt.style.transition = `transform ${ptIntroDur} var(--e-ritual)`;
      pt.style.transform = "scaleY(0)";
      setTimeout(() => { pt.style.transition = ""; pt.style.transform = ""; pt.style.transformOrigin = ""; }, narrow ? 380 : 700);
    }, 60);
    document.addEventListener("click", (e) => {
      if (e.defaultPrevented || e.target.closest("[data-add],[data-remove],button")) return;
      const a = e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (a.target === "_blank" || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:") || e.metaKey || e.ctrlKey || e.shiftKey || a.hasAttribute("download")) return;
      const url = new URL(a.href, location.href);
      const norm = (p) => p.replace(/index\.html$/, "");
      if (url.origin !== location.origin || (norm(url.pathname) === norm(location.pathname) && url.hash)) return;
      e.preventDefault();
      pt.classList.remove("reveal-out"); pt.classList.add("cover");
      setTimeout(() => (location.href = a.href), ptNavDelay);
    });
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) {
        pt.classList.remove("cover");
        pt.style.transition = "";
        pt.style.transform = "";
        pt.style.transformOrigin = "";
      }
    });
  }

  /* ---- marquee (duplicate track for seamless loop) ---- */
  document.querySelectorAll(".marquee-track").forEach((t) => { t.innerHTML += t.innerHTML; });

  /* ---- split-text reveal (data-split) - word-wrap; runInView adds .in ---- */
  document.querySelectorAll("[data-split]").forEach((el) => {
    if (reduced) return;
    const words = el.textContent.trim().split(" ");
    el.innerHTML = words.map((w) => `<span class="split-word"><span>${w}</span></span>`).join(" ");
    el.classList.add("split");
    el.querySelectorAll(".split-word > span").forEach((s, i) => (s.style.transitionDelay = i * 70 + "ms"));
  });
  /* count-up handled by runInView (scroll-driven). Re-scan now that .split exists. */
  if (window.__runInView) window.__runInView();

  /* ---- card / world tilt on hover ---- */
  if (fine && !reduced) {
    document.querySelectorAll(".card-media, .world").forEach((el) => {
      el.addEventListener("mousemove", (e) => {
        const r = el.getBoundingClientRect();
        const rx = ((e.clientY - r.top) / r.height - 0.5) * -6;
        const ry = ((e.clientX - r.left) / r.width - 0.5) * 6;
        el.style.transform = `perspective(800px) rotateX(${rx}deg) rotateY(${ry}deg)`;
      });
      el.addEventListener("mouseleave", () => (el.style.transform = ""));
    });
  }
})();
